import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row, Spinner, Table } from "react-bootstrap";
import Confirm from "../Confirm";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import SparkApi from "../../api/SparkApi";
import { Link } from "react-router-dom";
import helper from "../common/helper";
import * as constants from "../../constants/CONSTANT";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
// import RackCreate from "./RackCreate";
import InfoPill from "../InfoPill";
import { ShimmerTable } from "react-shimmer-effects";
import { toast, ToastContainer } from "react-toastify";
import RackCreate from "../racks/RackCreate";
import { usePermission } from "../context/PermissionContext";

var Barcode = require("react-barcode");
const WarehouseView = () => {
  const location = useLocation();
  const labels = { beforeSelect: " " };
  const navigate = useNavigate();
  const { id } = useParams();
  const [createShowModal, setCreateShowModal] = useState(false);
  const [warehouseRec, setWarehouseRec] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [rackdata, setRackdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [body, setBody] = useState([]);

  const { permissionData , userInfo} = usePermission();
  const can_edit = permissionData?.Warehouse?.can_edit;
  const can_delete = permissionData?.Warehouse?.can_delete;
  const can_create = permissionData?.Rack?.can_create;
  const can_read = permissionData?.Rack?.can_read;

  const columns = [
    {
      title: "Barcode",
      prop: "barcode",
      cell: (row) =>
        row.barcode ? (
          <Barcode value={row.barcode} width={1} height={25} />
        ) : (
          <span>No Barcode</span>
        ),
    },
    { title: "Rack Name", prop: "rackname", isFilterable: true },
    {
      title: "Products",
      prop: "products",
      cell: (row) =>
        row.products && row.products.length > 0 ? (
          row.products.map((product) => (
            <span className="mx-1" key={product.productid}>
              {product.productname},
            </span>
          ))
        ) : (
          <span>No Products</span>
        ),
    },
  ];

  useEffect(() => {
    fetchWarehouseData();
  }, []);

  const fetchWarehouseData = async () => {
    try {
      const warehouseResult = await SparkApi.fetchWarehouseById(id);
      if (warehouseResult.success) {
        setWarehouseRec(warehouseResult.records);
      } else {
        setWarehouseRec({});
      }
      const rackResult = await SparkApi.fetchfindallwarehouse(id);

      if (rackResult.success && rackResult.resultTask) {
        if(can_read){ 
        setRackdata(rackResult.resultTask[0].racks);
        const len = rackResult.resultTask.map((item) => {
          if (item.racks && Array.isArray(item.racks)) {
            return item.racks.length;
          }
          return 0;
        });
        const h = len[0];
        setBody(h);
      }
      } else {
        setRackdata([]);
        setBody([]);
      }
    } catch (error) {
      setError("Failed to fetch warehouse data.");
    } finally {
      setLoading(false);
    }
  };

  const deleteWarehouse = async () => {
    try {
      const result = await SparkApi.deleteWarehouse(warehouseRec.id);
      if (result.success) {
        toast.success("Warehouse deleted successfully");
        setTimeout(() => {
          navigate(`/warehouse`);
        }, 2000);
      } else {
        toast.error("Failed to delete the warehouse");
      }
    } catch (error) {
      toast.error("An error occurred while deleting the warehouse");
    }
  };

  const editAccount = () => {
    navigate(`/warehouse/${warehouseRec.id}/e`, { state: warehouseRec });
  };

  const createRack = () => {
    setCreateShowModal(true);
  };

  return (
    <Container>
      <ToastContainer theme="light" position="top-center" autoClose={2000} />

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <>
          {error && <div className="alert alert-danger">{error}</div>}
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteWarehouse={deleteWarehouse}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="warehouse"
            />
          )}
          <Row className=" border-bottom mb-3 my-2">
            <Col lg={2} className="mb-2">
              <Link className="nav-link" to="/warehouse">
                Home <i className="fa-solid fa-chevron-right"></i>{" "}
                <span style={{ color: "#23468c" }}>Warehouse</span>
              </Link>
            </Col>
          </Row>
          <Row className="view-form mb-3 justify-cotent-center">
            <Col lg={2}></Col>
            <Col lg={8}>
              <Row className="view-form-header align-items-center">
                <Col lg={8} xs={8}>
                  Warehouse<h5>{warehouseRec.name || ""}</h5>
                </Col>
                <Col lg={4} xs={4} className="d-flex justify-content-end">
                  {(userInfo?.userrole === "ADMIN" || can_edit) && 
                    (<Button
                      className="d-flex flex-col justify-content-end align-items-end"
                      onClick={editAccount}
                    >
                      <i className="fa-regular fa-pen-to-square"></i>
                    </Button>
                  )}
                  {(userInfo?.userrole === "ADMIN" || can_delete) && (
                    <Button
                      className="btn-sm mx-1"
                      variant="danger"
                      onClick={() => setModalShow(true)}
                    >
                      Delete
                    </Button>
                  )}
                </Col>
              </Row>
              <Row className="py-2 bg-white">
                <Col lg={6}>
                  <label>Name</label>
                  <span>{warehouseRec?.name || <br />}</span>
                </Col>
                <Col lg={6}>
                  <label>Fcatory</label>
                  <span>{warehouseRec?.factory_name || <br />}</span>
                </Col>
                <Col lg={6}>
                  <label>Address</label>
                  <span>{warehouseRec?.address || <br />}</span>
                </Col>
                <Col lg={6} xs={6}>
                  <label>City</label>
                  <span>{warehouseRec?.city || <br />}</span>
                </Col>
                <Col lg={6} xs={6}>
                  <label>State</label>
                  <span>{warehouseRec?.state || <br />}</span>
                </Col>
                <Col lg={6} xs={6}>
                  <label>Pincode</label>
                  <span>{warehouseRec?.pincode || <br />}</span>
                </Col>
                <Col lg={6} xs={6}>
                  <label>Country</label>
                  <span>{warehouseRec?.country || <br />}</span>
                </Col>
                {/* <Col lg={6}>
                  <label>Description</label>
                  <span>{warehouseRec?.description || <br />}</span>
                </Col> */}
                <Col lg={6}>
                  <label>Description</label>
                  <span
                    style={{
                      display: "block",
                      maxHeight: "4.5em", 
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      wordWrap: "break-word",
                    }}
                  >
                    {warehouseRec?.description || <br />}
                  </span>
                </Col>
               
              </Row>
            </Col>
            <Col lg={2}></Col>
          </Row>

          <Row className="g-0">
            <Col lg={12} className="">
              {createShowModal && (
                <RackCreate
                  show={createShowModal}
                  onHide={() => setCreateShowModal(false)}
                  recordId={id}
                  fetchWarehouseData={fetchWarehouseData}
                />
              )}
              {rackdata ? (
                <DatatableWrapper
                  body={rackdata}
                  headers={columns}
                  paginationOptionsProps={{
                    initialState: {
                      rowsPerPage: 15,
                      options: [5, 10, 15, 20],
                    },
                  }}
                >
                  <Row className="mb-4">
                    <Col
                      xs={12}
                      lg={3}
                      className="d-flex flex-col justify-content-end align-items-end"
                    >
                      <Filter />
                    </Col>
                    <Col
                      xs={9}
                      lg={4}
                      className="d-flex flex-col justify-content-start align-items-start"
                    >
                      <PaginationOptions labels={labels} />
                      <div className="mt-2">
                        <InfoPill left="Total Racks" right={body} />
                      </div>
                    </Col>
                    <Col
                      xs={3}
                      lg={5}
                      className="p-0 px-sm-3 d-flex flex-col justify-content-end align-items-end"
                    >
                      {(userInfo?.userrole === "ADMIN" || can_create && can_read) && (<Button
                        className="btn-sm rack-create-buuton"
                        onClick={() => createRack(true)}
                      >
                        New Rack
                      </Button>)}
                    </Col>
                  </Row>
                  <Table striped className="data-table" responsive>
                    <TableHeader />
                    <TableBody />
                  </Table>
                  <Pagination />
                </DatatableWrapper>
              ) : (
                <ShimmerTable row={10} col={4} />
              )}
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default WarehouseView;
